import React, {Component} from 'react'
import ItemDetailPage from "./ItemDetailPage"
import "../styles/index.scss"
import queryString from "query-string";


class ItemDetailPageContainer extends Component {
    render() {
        const {location} = this.props.history
        let params = {}
        if (location.search !== '') {
            params = queryString.parse(location.search)
        }

        return (
            <div className="ItemDetailPageContainer">
                <ItemDetailPage {...params}/>
            </div>
        )
    }
}

export default ItemDetailPageContainer
